import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import axios from 'axios';

const SmsVercode = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	
	const pageData = useSelector(state => state.pageData);
	const {csrf_token, acct_id, funnel_page_id, hook_status, preview, internaltest} = pageData;

	const contactFields = useSelector(state => state.contactFields);
	const {email, country_code, mobile} = contactFields;

	const [indicator, setIndicator] = useState('off');
	const [btnText, setBtnText] = useState(t('索取手機驗證碼'));

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);
	}, []);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('vercode', {
				validators: {
					notEmpty: {
						message: t('驗證碼不正確')
					}
				}
			});
		}
	}, [fv]);

	const onClick = async (e) => {
		if (!preview) {
			if (!country_code || !mobile) {
				openAlert(t('請輸入電話'));
			} else {
				setIndicator('on');

				const formData = new FormData();
				formData.append('_csrfToken', csrf_token);
				formData.append('internaltest', internaltest);
				formData.append('acct_id', acct_id);
				formData.append('funnel_page_id', funnel_page_id);
				formData.append('email', email);
				formData.append('country_code', country_code);
				formData.append('mobile', mobile);

				try {
					const response = await axios.post(`/SmsVercodes/ajaxGenCode`, formData);

					if (response.data.rc) {
						const data = response.data;
						
						if (internaltest == 'sandbox') {
							openAlert(data.message);
						}

						var final_time = new Date();
						final_time.setSeconds(final_time.getSeconds() + 120); // count down for 120 seconds

						const second = 1000,
							  minute = second * 60,
							  hour = minute * 60,
							  day = hour * 24;

						let countDown = new Date(final_time).getTime(),
						x = setInterval(function() {    
							let now = new Date().getTime(),
							distance = countDown - now;

							var seconds_diff = Math.floor(distance / (second));

							setBtnText(`${seconds_diff} ${t('秒')}`);

							// do something later when date is reached
							if (distance < 0) {
								clearInterval(x);

								setIndicator('off');
								setBtnText(t('索取手機驗證碼'));
							}
						}, second);
					} else {
						setIndicator('off');
						openAlert(response.data.rm);
					}
				} catch (e) {
					console.error(e);
				}
			}	
		}
	}

	return (
		<div className="flex-grow-1">
			<label className="form-label" htmlFor="vercode">{t('請輸入驗證碼')}</label>
			<div className="verifybox form-group">
				<input
					type="text"
					name="vercode"
					id="vercode"
					className="form-control"
				/>
				<div className="verify_button">
					<button
						type="button"
						className="btn btn-outline btn-outline-danger btn-md col-11"
						disabled={hook_status !== 'live' || indicator === 'on'}
						onClick={onClick}
						data-kt-indicator={indicator}
					>
						{btnText}
					</button>
				</div>    
			</div>   
		</div>
	);
}

export default SmsVercode;